import React, { useEffect, useState } from "react";

const NewSale = ({ item, items, setItems, index, handleRemove }) => {
  const [newItem, setNewItem] = useState({
    ...item,
    product_name: "",
    quantity: "",
    net_price: "",
    sub_total: "",
    bar_code: "",
  });

  useEffect(() => {
    setItems((pre) => {
      const i = [...pre];
      i[index] = {
        ...i[index],
        ...newItem,
      };
      return i;
    });
  }, [newItem]);

  useEffect(() => {
    const sub = newItem.quantity * newItem.net_price;
    setNewItem({ ...newItem, sub_total: sub });
  }, [newItem.quantity, newItem.net_price]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
      <input
        type="text"
        name="product_name"
        placeholder="Product Name*"
        className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
        required
        value={newItem.product_name}
        onChange={(e) => {
          setNewItem({ ...newItem, [e.target.name]: e.target.value });
        }}
      />
      <input
        type="number"
        name="quantity"
        placeholder="Quantity*"
        className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
        required
        value={newItem.quantity}
        onChange={(e) =>
          setNewItem({ ...newItem, [e.target.name]: e.target.value })
        }
      />
      <input
        type="number"
        name="net_price"
        placeholder="Net Price*"
        className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm md:mt-5 mt-0"
        required
        value={newItem.net_price}
        onChange={(e) =>
          setNewItem({ ...newItem, [e.target.name]: e.target.value })
        }
      />
      <input
        type="number"
        name="sub_total"
        placeholder="Total Price*"
        className="input  input-bordered w-full disabled  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm md:mt-5 mt-0"
        required
        value={newItem.sub_total}
      />
      <input
        type="text"
        name="bar_code"
        placeholder="Barcode*"
        className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm md:mt-5 mt-0"
        required
        value={newItem.bar_code}
        onChange={(e) =>
          setNewItem({ ...newItem, [e.target.name]: e.target.value })
        }
      />
      <div className="flex justify-around items-center">
        <a
          href="##"
          onClick={() => {
            //   setItems([...items, { id: Math.random() }]);
          }}
          className="btn tooltip tooltip-top flex justify-center items-center  btn-success md:mt-5 mt-0 text-white rounded-none"
          data-tip="Barcode Scanner"
        >
          <i className="fa-solid fa-barcode"></i>
        </a>
        <a
          href="##"
          onClick={() => handleRemove(item.id)}
          className="btn tooltip tooltip-top flex justify-center items-center btn-error md:mt-5 mt-0 text-white rounded-none"
          data-tip="Remove"
        >
          <i className="fa-solid fa-minus"></i>
        </a>
      </div>
    </div>
  );
};

export default NewSale;
